/// <reference path="../../jQuery/jquery-1.4.1-vsdoc.js"/>
if (!stuller)
	var stuller = {};

stuller.formHelper = function () {
    var pub = {
        textLimit: function (field, maxlen) {
            if (field.value.length > maxlen) {
                field.value = field.value.substring(0, maxlen);
            }
        },
        cleartextbox: function (currentObject, wordToRemove) {
            var currentValue = $.trim(currentObject.value.toLowerCase());
            if (currentValue == wordToRemove.toLowerCase()) {
                currentObject.value = '';
            }
        },
        filltextbox: function (currentObject, wordToInsert) {
            var currentValue = $.trim(currentObject.value.toLowerCase());
            if (currentValue == '' || currentValue == wordToInsert.toLowerCase()) {
                currentObject.value = wordToInsert;
            }
        },
        preventDoubleAction: function (currentObject, code, timeout, onTimeout) {
            if (currentObject.executingAction) {
                return false;
            }
            else {
                if (timeout == undefined)
                    timeout = 700;

                currentObject.executingAction = true;

                if (code != undefined)
                    code();

                setTimeout(function () { currentObject.executingAction = false; if (onTimeout != undefined) { onTimeout(); } }, timeout);
                return true;
            }
        },
        setCookie: function (name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            }
            else var expires = "";
            document.cookie = name + "=" + value + expires + "; path=/";
        },
        getCookie: function(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },
        submitFormBuilder: function(callback, additionalData) {
            var form = $(this).parents("form:first");
            if (typeof form.valid != 'undefined') {
                try {
                    if (!form.valid())
                        return;
                } catch(e) {
                }
            }

           var getJson = function(formData, nullValue) {
                if (formData == null) {
                    return null;
                }
                var json = {};
                $.each(formData, function () {
                    if (this.name != 'chooseAContact') {
                        if (json[this.name] !== undefined) {
                            if (!json[this.name].push) {
                                json[this.name] = [json[this.name]];
                            }
                            json[this.name].push(this.value || nullValue);
                        } else {
                            json[this.name] = this.value || nullValue;
                        }
                    }
                });
                return json;
            };

            var formSubmissionId = createGuid()

            var trackFormEvent = function(formDataCms) {
                if (formDataCms.AnalyticsName != null) {
                    dispatchStullerEvent('track-event', {
                        event: 'form_completed',
                        details: {
                            form_name: formDataCms.AnalyticsName,
                            generate_lead: formDataCms.AnalyticsGenerateLead,
                            value: formDataCms.AnalyticsValue,
                            currency: formDataCms.AnalyticsCurrency,
                            form_submission_id: formSubmissionId
                        }
                    })
                }
            }

            var contactData = null;
            var contactHtml = form.find(".contact-form");
            if (contactHtml.length > 0) {
                contactData = contactHtml.find(":input").serializeArray();
            }

            var allJson = getJson(form.serializeArray(), '');
            if (additionalData) {
                for (x in additionalData) {
                    allJson[x] = additionalData[x];
                }
            }
            allJson.formSubmissionId = formSubmissionId
            var contactJson = getJson(contactData, null);
            var crmJson = JSON.parse(JSON.stringify(allJson)); //clone

            for (key in contactJson) {
                delete crmJson[key];
            }

            // Get form data from CMS data attribute
            var formDataCms = null
            if (form.data("cms") != null) {
                formDataCms = form.data("cms")
            }

            var msg = form.children(".fb-message").hide().removeClass("error").removeClass("success_message");

            $.post(form.attr("action"), {
                json: JSON.stringify(allJson),
                contact: JSON.stringify(contactJson),
                crmJson: JSON.stringify(crmJson)
            }, function(result) {
                if (result.success) {
                    if (formDataCms != null) {
                        trackFormEvent(formDataCms)
                    }
                    if (result.is_url) {
                        if (callback)
                            callback(result);
                        window.location = result.message;
                        return;
                    } else {
                        msg.html(result.message).show();
                        msg.addClass("success_message");
                        form.find('.fb-form').hide();
                    }
                } else {
                    msg.html(result.message).show();
                    msg.addClass("error");
                }

                if (callback)
                    callback(result);
            }).fail(function() {
                msg.html("We're sorry. We were unable to process your form at this time.").show();
                msg.addClass('error');
            });
        }
    };

    addStullerEventListener('form-builder-submission', function (event) {
      var callback = event.detail != null ? event.detail.callback : undefined
      var data = event.detail != null ? event.detail.data : undefined
      pub.submitFormBuilder.call(event.detail.target, callback, data)
    })

    return pub;
} ();
